import { supabase } from '@/lib/supabase/client'

export interface LeadData {
  name: string
  email: string
  phone: string
  city?: string
  businessName?: string
  activityType?: string
  message?: string
}

export const submitLead = async (data: LeadData) => {
  // Use 'as any' to bypass strict type checking against generated types
  // which haven't been regenerated to reflect the nullable columns
  const payload = {
    name: data.name,
    email: data.email,
    phone: data.phone,
    city: data.city || null,
    business_name: data.businessName || null,
    activity_type: data.activityType || null,
    message: data.message || null,
  }

  // 1. Insert into Database
  const { error } = await supabase.from('leads').insert(payload as any)

  if (error) {
    console.error('Error submitting lead:', error)
    throw error
  }

  // 2. Trigger Notification Edge Function (Fire and Forget logic for UI speed, but mapped to wait for simplicity in error logging)
  // We don't want to fail the user request if the email fails, but we want to log it.
  try {
    const { error: funcError } = await supabase.functions.invoke(
      'notificar-equipe',
      {
        body: payload,
      },
    )

    if (funcError) {
      console.error('Failed to trigger notification function:', funcError)
    }
  } catch (err) {
    // Catch any network or execution errors from the edge function invocation
    console.error('Exception calling notification function:', err)
  }

  return true
}
